import script from "./GalleryBase.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryBase.vue?vue&type=script&setup=true&lang=js"

import "./GalleryBase.vue?vue&type=style&index=0&id=931f2cfe&lang=scss"

const __exports__ = script;

export default __exports__